export default {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
};
